import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { getEndpoint } from '@app/utils/get-endpoint'
import { firstValueFrom } from 'rxjs'

@Injectable({
	providedIn: 'root',
})
export class SettingsService {
	#settingsService: string = 'Settings'

	constructor(private readonly http: HttpClient) {}

	/** /api/v1/Settings/GetFeatureFlags */
	public async getFeatureFlags(): Promise<any> /* TODO: set up models */ {
		try {
			return firstValueFrom(this.http.get(getEndpoint([this.#settingsService, 'GetFeatureFlags'])))
		} catch (err) {
			return Promise.reject(err)
		}
	}
}
